import type { FC } from 'react';

import { userMessageBubbleCss, userMessageCss } from './UserMessage.styles';

interface UserMessageProps {
  content: string;
}

/** Renders a user-submitted message bubble aligned to the right of the conversation. */
export const UserMessage: FC<UserMessageProps> = ({ content }) => (
  <div className={userMessageCss}>
    <div className={userMessageBubbleCss}>{content}</div>
  </div>
);

UserMessage.displayName = 'UserMessage';
